import { render, staticRenderFns } from "./EtiquetaOP.vue?vue&type=template&id=1875dc16&"
import script from "./EtiquetaOP.vue?vue&type=script&lang=js&"
export * from "./EtiquetaOP.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports